// Unified optical grid: rounded 1.65-unit strokes, no gradients or decorative fills.
import React from 'react';

const makeIcon = (drawing, viewBox = '0 0 24 24') => {
  const Icon = ({ color = 'currentColor', size = 36 }) => (
    <svg width={size} height={size} viewBox={viewBox} fill="none" stroke="currentColor"
      strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"
      style={{color, flexShrink:0}} aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">{drawing}</svg>
  );
  return Icon;
};

export const IconAdmision = makeIcon(<><rect x="5" y="4" width="14" height="17" rx="2.5"/><rect x="9" y="2.5" width="6" height="3" rx="1" fill="var(--icon-surface, white)"/><path d="M12 9v5m-2.5-2.5h5M9 17h6"/></>);

export const IconEmergencia = makeIcon(<><path d="M20.2 4.8a5 5 0 0 0-7.1 0L12 5.9l-1.1-1.1a5 5 0 0 0-7.1 7.1L12 20l8.2-8.1a5 5 0 0 0 0-7.1Z"/><path d="M3 11h4l2-3 3 7 2-4h4"/></>);

export const IconCaja = makeIcon(<><rect x="3" y="10" width="18" height="11" rx="2.5"/><path d="M6 10V5h12v5M9 5V3h6v2M3 16h18M10 18.5h4"/><path d="M7 13h.01M11 13h.01M15 13h2"/></>);

export const IconConsultorios = makeIcon(<><path d="M5 3v5a4 4 0 0 0 8 0V3M4 3h2m6 0h2M9 12v3a5 5 0 0 0 10 0v-2"/><circle cx="19" cy="10" r="2.5"/></>);

export const IconEconomia = makeIcon(<><path d="M4 20h16M6 16v-4m6 4V9m6 7V5M5 7l6-3 4 2 5-3"/></>);

export const IconEcografia = makeIcon(<><rect x="3" y="3" width="18" height="14" rx="2.5"/><path d="M8 21h8m-4-4v4M7 8a7 7 0 0 0 10 0M8.5 11a5 5 0 0 0 7 0"/></>);

export const IconFarmacia = makeIcon(<><rect x="7" y="2.5" width="10" height="4" rx="1.3"/><path d="M8 6.5v2L5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8l-3-2.5v-2M9 15h6m-3-3v6"/></>);

export const IconHospitalizacion = makeIcon(<><path d="M3 6v15m18-9v9M3 17h18M3 12h15a3 3 0 0 1 3 3v2M10 12V8h7a4 4 0 0 1 4 4"/><rect x="4.5" y="8" width="4" height="4" rx="1"/></>);

export const IconLaboratorio = makeIcon(<><path d="M9 3h6m-5 0v7L4.8 18a2 2 0 0 0 1.7 3h11a2 2 0 0 0 1.7-3L14 10V3M8 15h8"/><circle cx="10" cy="18" r=".65" fill="currentColor" stroke="none"/><circle cx="14" cy="17.5" r=".65" fill="currentColor" stroke="none"/></>);

export const IconRayosX = makeIcon(<><rect x="4" y="2.5" width="16" height="19" rx="2.5"/><path d="M12 6v12M12 8c-2-2-4-1-4 1m4-1c2-2 4-1 4 1M12 11c-2-1.5-4-.5-4 1.5m4-1.5c2-1.5 4-.5 4 1.5M12 14c-2-1-3.5 0-3.5 2m3.5-2c2-1 3.5 0 3.5 2"/></>);

export const IconSeguros = makeIcon(<><path d="m12 3 8 3v6c0 4.5-3.5 7.5-8 9-4.5-1.5-8-4.5-8-9V6l8-3Z"/><path d="M12 8v7m-3.5-3.5h7"/></>);

export const IconUsuarios = makeIcon(<><circle cx="9" cy="7.5" r="3.5"/><path d="M2.5 21v-2a6.5 6.5 0 0 1 13 0v2M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14a5 5 0 0 1 3.5 5v2"/></>);

export const IconVentas = makeIcon(<><path d="M3 3h2l2.4 12h11.1L21 7H6M8 18h11"/><circle cx="9" cy="21" r=".8"/><circle cx="18" cy="21" r=".8"/></>);

export const IconAnulaciones = makeIcon(<><path d="M13 4h5a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-5M3 6h8m-8 0 3-3M3 6l3 3M10 12l5 5m0-5-5 5"/></>);

export const IconKardex = makeIcon(<><rect x="5" y="3" width="15" height="18" rx="2.5"/><path d="M9 3v18M3 7h4m-4 5h4m-4 5h4M12 8h5m-5 4h5m-5 4h3"/></>);

export const IconInventario = makeIcon(<><path d="m3 8 9-5 9 5-9 5-9-5Zm0 0v10l9 5 9-5V8m-9 5v10M7.5 5.5l9 5v4"/></>);

export const IconAjustes = makeIcon(<><path d="M4 6h7m5 0h4M4 12h2m5 0h9M4 18h10m5 0h1"/><circle cx="13.5" cy="6" r="2.5"/><circle cx="8.5" cy="12" r="2.5"/><circle cx="16.5" cy="18" r="2.5"/></>);

export const IconStock = makeIcon(<><rect x="3" y="4" width="18" height="5" rx="1.5"/><path d="M5 9v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9M9 13h6m-5 4h4"/></>);

export const IconAlmacen = makeIcon(<><path d="M3 21V9l9-6 9 6v12M7 21V11h10v10M7 15h10M7 18h10M2 21h20"/></>);

export const IconProductos = makeIcon(<><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Zm-8 4.5 8 4.5 8-4.5M12 12v9M8 5.3l8 4.5"/></>);

export const IconReporte = makeIcon(<><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Zm0 0v6h6M8 17v-3m4 3v-6m4 6v-4"/></>);

export const IconIndicadores = makeIcon(<><path d="M3 3v18h18M7 15l4-5 4 3 6-8m-5 0h5v5"/></>);

export const IconConsumos = makeIcon(<><path d="m3 7 7-4 7 4-7 4-7-4Zm0 0v9l7 4 3-1.7M10 11v9M16 7v5M14 16h8m-3-3 3 3-3 3"/></>);

export const IconConsumoPac = makeIcon(<><circle cx="8.5" cy="6.5" r="3.5"/><path d="M2 21v-2a6.5 6.5 0 0 1 9-6"/><g transform="rotate(35 17.5 16)"><rect x="14" y="10" width="7" height="12" rx="3.5"/><path d="M14 16h7"/></g></>);

export const IconRequerimiento = makeIcon(<><rect x="4" y="4" width="15" height="17" rx="2.5"/><rect x="8" y="2" width="7" height="4" rx="1.5" fill="var(--icon-surface, white)"/><path d="M8 10h7m-7 4h4m3 3h7m-3-3 3 3-3 3"/></>);

export const IconNarcoticos = makeIcon(<><path d="M6 3h8v4H6zM7 7v2l-3 3v7a2 2 0 0 0 2 2h5M13 7v2l2 2M7 14h3"/><rect x="14" y="16" width="7" height="6" rx="1.5"/><path d="M15.5 16v-2a2 2 0 0 1 4 0v2"/></>);

export const IconPsicotropicos = makeIcon(<><path d="M12 5a3 3 0 0 0-5.8-1A3.5 3.5 0 0 0 4 10a4 4 0 0 0 1 7.5A3.5 3.5 0 0 0 12 19V5Zm0 0a3 3 0 0 1 5.8-1A3.5 3.5 0 0 1 20 10a4 4 0 0 1-1 7.5A3.5 3.5 0 0 1 12 19M7 8l2 2m-4 4h3m9-6-2 2m4 4h-3"/></>);

export const IconConteo = makeIcon(<><rect x="6" y="4" width="14" height="17" rx="2.5"/><rect x="10" y="2" width="6" height="4" rx="1.5" fill="var(--icon-surface, white)"/><path d="m3 11 1.5 1.5L8 9m-5 9 1.5 1.5L8 16m3-5h5m-5 7h5"/></>);

export const IconDevoluciones = makeIcon(<><path d="M3 9h11a6 6 0 0 1 0 12h-4M3 9l5-5M3 9l5 5"/></>);

export const IconComprobantes = makeIcon(<><path d="M5 3h14v18l-3-2-4 2-4-2-3 2V3ZM9 7h6m-6 4h6m-6 4h3"/></>);

export const IconLibroVentas = makeIcon(<><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v18H6.5a2.5 2.5 0 0 1 0-5H20M4 5.5v13M8 3v13m4-9h4m-4 4h4"/></>);

export const IconConsultaCpe = makeIcon(<><path d="M10 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8l5 5v2M14 3v5h5M8 8h2m-2 4h2"/><circle cx="16" cy="16" r="4"/><path d="m19 19 3 3"/></>);

export const IconMonitorEnvios = makeIcon(<><rect x="3" y="3" width="18" height="13" rx="2.5"/><path d="M8 21h8m-4-5v5M7 10h10m-3-3 3 3-3 3"/></>);

export const IconCuentasCobrar = makeIcon(<><rect x="3" y="4" width="18" height="13" rx="2.5"/><circle cx="12" cy="10.5" r="2.5"/><path d="M6 8h.01M18 13h.01M8 21h11m-3-3 3 3-3 2"/></>);

export const IconRoles = makeIcon(<><circle cx="8" cy="8" r="4.5"/><path d="m11.2 11.2 9.3 9.3m-3-3 3-3m-6 0 3-3"/></>);

export const IconTablero = makeIcon(<><rect x="3" y="3" width="7" height="8" rx="2"/><rect x="14" y="3" width="7" height="5" rx="2"/><rect x="3" y="15" width="7" height="6" rx="2"/><rect x="14" y="12" width="7" height="9" rx="2"/></>);

export const IconTarifario = makeIcon(<><path d="M3 4h9l9 9-8 8-10-10V4Z"/><circle cx="7.5" cy="8" r="1"/><path d="m12 10 4 4m-6-2 4 4"/></>);

export const IconSesiones = makeIcon(<><circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/></>);

export const IconProcedimientos = makeIcon(<><rect x="4" y="5" width="16" height="16" rx="2.5"/><path d="M8 5V3h8v2M12 10v6m-3-3h6"/></>);

export const IconAuditoria = makeIcon(<><path d="m12 3 8 3v6c0 4.5-3.5 7.5-8 9-4.5-1.5-8-4.5-8-9V6l8-3Z"/><path d="m8 12 3 3 5-6"/></>);

export const IconValidacionRc = makeIcon(<><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Zm0 0v6h6m-12 6 3 3 5-6"/></>);

export const IconKardexFarmacia = makeIcon(<><rect x="5" y="3" width="15" height="18" rx="2.5"/><path d="M3 7h4m-4 5h4m-4 5h4M13.5 7v6m-3-3h6M11 17h5"/></>);

export const IconConsumoPacSis = makeIcon(<><circle cx="8" cy="6" r="3"/><path d="M2 21v-3a6 6 0 0 1 9-5m6-3 5 2v4c0 3-3 5-5 6-2-1-5-3-5-6v-4l5-2Z"/><path d="m14.5 16 2 2 3-4"/></>);

// Two hollow capsule halves outline a heart; the detached mouths release three beads.
export const IconDataFarma = makeIcon(<>
  <g strokeWidth="1.7">
    <path d="m13 22-8.5-8.5a4.95 4.95 0 0 1 7-7L20 15"/>
    <ellipse cx="16.5" cy="18.5" rx="4.95" ry="1.05" transform="rotate(-45 16.5 18.5)"/>
    <path d="m17 10 5.5-5.5a4.95 4.95 0 0 1 7 7L24 17"/>
    <ellipse cx="20.5" cy="13.5" rx="4.95" ry="1.05" transform="rotate(45 20.5 13.5)"/>
  </g>
  <circle cx="19" cy="24" r="1.35" strokeWidth="1.34"/>
  <circle cx="14.5" cy="27" r="1" strokeWidth="1.24"/>
  <circle cx="20" cy="29.5" r=".7" fill="currentColor" stroke="none"/>
</>, '0 0 34 33');

// Mapa completo de id → componente ícono (módulos + opciones)
export const ICONOS_MODULOS = {
  admision:        IconAdmision,
  emergencia:      IconEmergencia,
  caja:            IconCaja,
  consultorios:    IconConsultorios,
  economia:        IconEconomia,
  ecografia:       IconEcografia,
  farmacia:        IconFarmacia,
  hospitalizacion: IconHospitalizacion,
  laboratorio:     IconLaboratorio,
  rayosx:          IconRayosX,
  seguros:         IconSeguros,
  usuarios:        IconUsuarios,
  // opciones farmacia
  ventas:          IconVentas,
  anulaciones:     IconAnulaciones,
  kardex:          IconKardex,
  inventario:      IconInventario,
  ajustes:         IconAjustes,
  stock:           IconStock,
  almacen:         IconAlmacen,
  productos:       IconProductos,
  reporte:         IconReporte,
  indicadores:     IconIndicadores,
  consumos:        IconConsumos,
  consumopac:      IconConsumoPac,
  requerimiento:   IconRequerimiento,
  narcoticos:      IconNarcoticos,
  psicotropicos:   IconPsicotropicos,
  conteo:          IconConteo,
  devoluciones:    IconDevoluciones,
  // opciones economia
  comprobantes:    IconComprobantes,
  'libro-ventas':  IconLibroVentas,
  'consulta-cpe':  IconConsultaCpe,
  'monitor-envios': IconMonitorEnvios,
  'cuentas-cobrar': IconCuentasCobrar,
  roles: IconRoles,
  tablero: IconTablero,
  tarifario: IconTarifario,
  sesiones: IconSesiones,
  procedimientos: IconProcedimientos,
  datafarma: IconDataFarma,
  auditoria:       IconAuditoria,
validacionrc:    IconValidacionRc,
kardexfarmacia:  IconKardexFarmacia,
'consumopac-sis': IconConsumoPacSis,
};

// Colores para opciones
export const COLORES_MODULOS = {
  // módulos raíz
  admision:        { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  emergencia:      { reposo: '#8E8E93', activo: '#FF3B30', fondo: '#FFF0EF' },
  caja:            { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  consultorios:    { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  economia:        { reposo: '#8E8E93', activo: '#FF9500', fondo: '#FFF5E6' },
  ecografia:       { reposo: '#8E8E93', activo: '#32ADE6', fondo: '#EBF7FF' },
  farmacia:        { reposo: '#8E8E93', activo: '#5E5CE6', fondo: '#F0EFFF' },
  hospitalizacion: { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  laboratorio:     { reposo: '#8E8E93', activo: '#FF9500', fondo: '#FFF5E6' },
  rayosx:          { reposo: '#8E8E93', activo: '#32ADE6', fondo: '#EBF7FF' },
  seguros:         { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  usuarios:        { reposo: '#8E8E93', activo: '#5E5CE6', fondo: '#F0EFFF' },
  // opciones farmacia integra
  ventas:          { reposo: '#8E8E93', activo: '#5E5CE6', fondo: '#F0EFFF' },
  anulaciones:     { reposo: '#8E8E93', activo: '#FF3B30', fondo: '#FFF0EF' },
  kardex:          { reposo: '#8E8E93', activo: '#5E5CE6', fondo: '#F0EFFF' },
  inventario:      { reposo: '#8E8E93', activo: '#FF9500', fondo: '#FFF5E6' },
  ajustes:         { reposo: '#8E8E93', activo: '#8E8E93', fondo: '#F2F2F7' },
  stock:           { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  // opciones farmacia sismed
  almacen:         { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  productos:       { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  reporte:         { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  indicadores:     { reposo: '#8E8E93', activo: '#FF9500', fondo: '#FFF5E6' },
  consumos:        { reposo: '#8E8E93', activo: '#32ADE6', fondo: '#EBF7FF' },
  consumopac:      { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  requerimiento:   { reposo: '#8E8E93', activo: '#5E5CE6', fondo: '#F0EFFF' },
  narcoticos:      { reposo: '#8E8E93', activo: '#FF3B30', fondo: '#FFF0EF' },
  psicotropicos:   { reposo: '#8E8E93', activo: '#FF9500', fondo: '#FFF5E6' },
  conteo:          { reposo: '#8E8E93', activo: '#8E8E93', fondo: '#F2F2F7' },
  devoluciones:    { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  // opciones economía
  comprobantes:    { reposo: '#8E8E93', activo: '#FF9500', fondo: '#FFF5E6' },
  'libro-ventas':  { reposo: '#8E8E93', activo: '#5E5CE6', fondo: '#F0EFFF' },
  'consulta-cpe':  { reposo: '#8E8E93', activo: '#007AFF', fondo: '#EBF5FF' },
  'monitor-envios':{ reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  'cuentas-cobrar': { reposo: '#8E8E93', activo: '#FF9500', fondo: '#FFF5E6' },
  roles: { reposo: '#8E8E93', activo: '#5E5CE6', fondo: '#F0EFFF' },

  datafarma: { reposo:'#8E8E93', activo:'#007AFF', fondo:'#F3F0FF' },
  auditoria:        { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  validacionrc:     { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  kardexfarmacia:   { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
  'consumopac-sis': { reposo: '#8E8E93', activo: '#34C759', fondo: '#EDFAF2' },
};
